import Button from './Button';
import Feedbackclose from '../assets/icons/Feedbackclose';
import Loader from './Loader';
import ButtonNew from './ButtonNew';

const ModalBox = ({
    close,
    onSubmit,
    loading,
    primaryBtnText,
    secondaryBtnText,
    children,
    width = 'w-[518px]',
    isConfirmModal = true,
    isTypeSubmit = false,
    supportText
}) => {
    return (
        <div className={`p-6 ${width}`}>
            <div>

                <ButtonNew
                    onClick={close}
                    variant="closeNeutral"
                    size="xs"
                    shape="oval"
                    className="absolute top-3 right-4 !p-0"
                    fixedMinWidth
                    minWidthClass="min-w-[2.5rem]"
                >
                    <Feedbackclose />
                </ButtonNew>
            </div>
            {isConfirmModal ? (

                <div className='w-full' >
                    <p className="text-xl w-[90%] text-textPrimary">{children}</p>
                    {supportText && <p className='text-textSecondary mt-2'>{supportText}</p>}
                </div>


            ) : (
                <div className="w-[100%]">{children}</div>
            )}
            {isConfirmModal && (
                <div className="flex items-center mt-6 gap-3">
                    <ButtonNew
                        type={isTypeSubmit ? 'submit' : 'button'}
                        fixedMinWidth={true}
                        variant="blue"
                        shape='oval'
                        size="sm"
                        onClick={onSubmit}
                    >
                        {loading ? <Loader /> : primaryBtnText}
                    </ButtonNew>
                    <ButtonNew
                        type='button'
                        fixedMinWidth={true}
                        variant="neutral"
                        shape='oval'
                        size="sm"
                        onClick={close}
                    >
                        {secondaryBtnText}
                    </ButtonNew>

                </div>
            )}
        </div>
    );
};

export default ModalBox;
